<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section class="section--account-details" id="scrollToOnLoad" v-if="user">
      <b-container class="container--wide">
        <div class="account">
          <b-row>
            <b-col cols="8" sm="5" offset="2" offset-sm="0" class="account__avatar text-center">
              <img v-if="!this.avatar"
                class="img-fluid account__photo"
                :src="domain + user.avatar" alt="">
              <img v-else class="img-fluid account__photo" :src="avatar.base64" alt="">
              <button
                type="button"
                @click="addPhoto"
                class="account__add-avatar">
                <i class="fas fa-plus fa-3x"></i>
              </button>
              <upload-base64 :multiple="false" :done="getFiles" ref="file_input"></upload-base64>
            </b-col>
            <b-col sm="7" class="account__position">
              <h1 class="text--black">{{ $t("hello") }}, {{user.first_name}}</h1>
              <span class="account__name"> {{userType}} </span>
              <div class="d-flex justify-content-lx-between">
              </div>
            </b-col>
          </b-row>
          <b-form class="account__edit">
            <b-row>
              <b-col sm="6">
                <b-form-input
                  type="text"
                  v-model="user.first_name"
                  :state="!errors.first_name"
                  required placeholder="First name"
                  class="mb-3">
                </b-form-input>
                <b-form-invalid-feedback>
                  <span v-for="(error, index) in errors.first_name" :key="index">
                    {{error}}
                  </span>
                </b-form-invalid-feedback>
              </b-col>
              <b-col sm="6">
                <b-form-input
                  type="text"
                  v-model="user.last_name"
                  :state="!errors.last_name"
                  required placeholder="Last name"
                  class="mb-3">
                </b-form-input>
                <b-form-invalid-feedback>
                  <span v-for="(error, index) in errors.last_name" :key="index">
                    {{error}}
                  </span>
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-form-input
              v-if="userType === 'student'"
              type="text"
              :value="user.teacher.school"
              required placeholder="School name"
              disabled
              class="mb-3">
            </b-form-input>
            <b-form-input
              v-else
              type="text"
              :value="user.school"
              required placeholder="School name"
              disabled
              class="mb-3">
            </b-form-input>
            <b-form-input
              type="email"
              :value="user.email"
              disabled
              required placeholder="E-mail address"
              class="mb-3">
            </b-form-input>
            <b-form-input
              type="number"
              v-if="userType!='student'"
              v-model="user.phone_number"
              :state="!errors.phone_number"
              required placeholder="Phone number"
              class="mb-3">
            </b-form-input>
            <b-form-invalid-feedback>
                  <span v-for="(error, index) in errors.phone_number" :key="index">
                    {{error}}
                  </span>
            </b-form-invalid-feedback>
            <b-form-input
              type="password"
              v-model="user.password"
              :state="!errors.password"
              required :placeholder="$t('password')"
              class="mb-3">
            </b-form-input>
            <b-form-invalid-feedback>
                  <span v-for="(error, index) in errors.password" :key="index">
                    {{error}}
                  </span>
            </b-form-invalid-feedback>
            <b-form-input
              type="password"
              v-model="user.password_confirmation"
              :state="!errors.password_confirmation"
              required placeholder="Verify New Password">
            </b-form-input>
            <b-form-invalid-feedback>
                  <span v-for="(error, index) in errors.password_confirmation" :key="index">
                    {{error}}
                  </span>
            </b-form-invalid-feedback>
          </b-form>
          <b-row>
            <b-col class="d-flex flex-column flex-sm-row justify-content-sm-end
              mt-4 mt-md-2 mt-lg-0">
              <b-btn class="mr-sm-3 mb-2 mb-sm-0"
                variant="primary"
                size="sm"
                @click="updateUserData">
                {{ $t("save") }}
              </b-btn>
              <b-btn variant="primary" size="sm" @click="cancel">{{ $t("cancel") }}</b-btn>
            </b-col>
        </b-row>
      </div>
    </b-container>
   </section>
   <section-support></section-support>
  </main>
</template>

<script>
import student from '@/api/v1/student';
import teacher from '@/api/v1/teacher';
import auth from '@/api/v1/auth';
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';
import UploadBase64 from '@/components/UploadBase64';

export default {
  data() {
    return {
      bgImg: 'Banner5-My_Account-',
      subtitle: this.$t('nav.myAccount'),
      userType: auth.user.user_type,
      user: null,
      avatar: null,
      domain: process.env.SERVER_URL,
      errors: [],
    };
  },
  components: {
    'section-hero': Hero,
    'section-support': Support,
    UploadBase64,
  },
  methods: {
    getUserData() {
      const succ = (response) => { this.user = response; };
      if (this.userType === 'student') {
        student.show(succ);
      } else {
        teacher.show(succ);
      }
    },
    updateUserData() {
      if (this.avatar) {
        this.user.avatar = this.avatar.base64;
      }
      const succ = () => {
        this.$router.push({ path: 'user_profile' });
      };
      const err = (error) => {
        if (error.response) {
          this.errors = error.response.data.errors;
        }
      };
      if (this.userType === 'student') {
        student.update(this.user, succ, err);
      } else {
        teacher.update(this.user, succ, err);
      }
    },
    getFiles(files) {
      this.avatar = files;
    },
    addPhoto() {
      this.$refs.file_input.$refs.input.click();
    },
    cancel() {
      this.$router.push({ path: 'user_profile' });
    },
  },
  created() {
    this.getUserData();
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.section--account-details {
  padding: 100px 0 0;
  @include media("<md") {
    padding-top: 40px;
  }
}
.account {
  background-color: #e4e4e4;
  padding: 135px 97px 130px 97px;
  margin-bottom: 100px;
  @include media("<lg") {
    padding: 50px 88px 50px 88px;
  }
  @include media("<md") {
    padding: 40px 30px;
    margin-bottom: 40px;
  }
  &__position {
    padding-top: 50px;
  }
  &__name {
    text-transform: capitalize;
    color: $color--gray-3;
    font-size: 28px;
    line-height: 28px;
    display: block;
    padding-top: 10px;
    @include media("<lg") {
      font-size: 16px;
    }
    @include media("<md") {
      padding-top: 0;
    }
  }
  &__edit {
    padding-top: 30px;
  }
  &__avatar {
    position: relative;
  }
  &__add-avatar {
    position: absolute;
    top: -20px;
    right: 58px;
    color: $color--white;
    transition: color ease 0.3s;
    @include media('<xl') {
      right: 20px;
    }
    @include media('<lg') {
      right: -7px;
    }
    &:hover {
      color: $color--orange;
    }
  }
  &__photo {
    width: 250px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/User/AccountDetails.vue